// errorMessages.js
export const errorTranslations = {
    "MENU_NOT_FOUND": "Menü bulunamadı",
    "MENU_ACTIVE": "Aktif menüyü silemezsiniz",
    "MENU_HAS_CATEGORIES": "Menüye bağlı kategoriler mevcut. Lütfen önce kategorileri silin",
    "MENU_HAS_ITEMS": "Menüye bağlı ürünler mevcut. Lütfen önce ürünleri silin",
    "VENUE_HAS_ACTIVE_ORDERS": "İşletmenizde aktif siparişler mevcuttur. Lütfen mevcut siparişleri tamamlayın.",
    "CATEGORY_NOT_FOUND": "Kategori bulunamadı.",
    "CATEGORY_HAS_ITEMS": "Bu kategoride ürünler var. Kategoriyi silmeden önce tüm ürünleri kaldırın.",
    "SYSTEM_CATEGORY_CANNOT_BE_DELETED": "Sistem kategorileri silinemez.",
    "MENU_ID_MISMATCH": "Menü ile kategori uyuşmazlığı.",
    "AREA_HAS_USERS": "Bu alanda bağlı kullanıcılar var, bu nedenle alan silinemiyor.",
    "AREA_HAS_ITEMS": "Bu alanda bağlı ürünler var, bu nedenle alan silinemiyor.",
    "default": "Bir hata oluştu. Lütfen tekrar deneyin."
  };
  